import React, { createContext, useContext, useState } from "react";
import { IntlProvider } from "react-intl";
import ja from "./locales/ja.json";
import en from "./locales/en.json";

const messages = { ja, en };

const I18nContext = createContext();
export const useI18n = () => useContext(I18nContext);

export default function I18nProvider({ children }) {
  const defaultLocale = navigator.language.startsWith("ja") ? "ja" : "en";
  const [locale, setLocale] = useState(defaultLocale);

  return (
    <I18nContext.Provider value={{ locale, setLocale }}>
      <IntlProvider locale={locale} messages={messages[locale]}>
        {children}
      </IntlProvider>
    </I18nContext.Provider>
  );
}
